module.exports = __webpack_public_path__ + "img/danger-icon.a93eb047.png";